import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import BaseLayout from '../ui-bloom/layouts/LayoutContainer/BaseLayout'
import NotFound from '../pages/NotFound'
import UserSettings from '../components/UserDashboard/UserProfile'
import ProtectedRoute from './ProtectedRoute';
import AdminSignup from '../pages/AdminSignUp';
import AdminSignIn from '../pages/AdminSignIn';
import Login from '../pages/Login';
import ManageIssuersByAdmin from '../components/AdminDashboard/ManageIssuersByAdmin/ManageIssuersByAdmin'
import ManageCredentialsByAdmin from '../components/AdminDashboard/ManageCredentialsByAdmin/ManageCredentialsByAdmin'
import ManageAssignmentsByAdmin from '../components/AdminDashboard/ManageAssignmentsByAdmin/ManageAssignmentsByAdmin'
import ManageCompaniesByAdmin from '../components/AdminDashboard/ManageCompaniesByAdmin/ManageCompaniesByAdmin'
import ManageUsersByAdmin from '../components/AdminDashboard/ManageUsersByAdmin/ManageUsersByAdmin'
import ManageCredentialsByIssuer from '../components/IssuerDashboard/ManageCredentialsByIssuer/ManageCredentialsByIssuer'
import ManageUsersByIssuer from '../components/IssuerDashboard/ManageUsersByIssuer/ManageUsersByIssuer';
import ManageAssignmentsByIssuer from '../components/IssuerDashboard/ManageAssignmentsByIssuer/ManageAssignmentsByIssuer'
import ManageCompaniesByIssuer from '../components/IssuerDashboard/ManageCompaniesByIssuer/ManageCompaniesByIssuer'
import AccessDenied from '../pages/AccessDenied';
import IssuerSignup from '../pages/IssuerSignup';
import ApproveBadgeAssignment from '../pages/ApproveBadgeAssignment';
import BadgePage from '../pages/BadgePage';
import BadgeProfile from '../components/UserDashboard/BadgeProfile';
import IssuerProfile from '../components/IssuerDashboard/IssuerProfile';
import AdminProfile from '../components/AdminDashboard/AdminProfile';
import UserProfile from '../components/UserDashboard/UserProfile';
import UserSignUp from '../pages/UserSignUp';
import UserDashboard from '../components/UserDashboard/UserDashboard';
import PasswordResetSuccessMessage from '../pages/PasswordResetSuccessMessage';
import ProfileCheck from '../pages/ProfileCheck';
import IssuerBadgesProfile from '../components/IssuerDashboard/IssuerBagesProfile';
import IssuerBadgePage from '../pages/IssuerBadgePage';
import ApproveBadges from '../components/UserDashboard/ApproveBadges';
import RoleSelection from '../pages/RoleSelection';
import CompanyIssuerSignup from '../pages/CompanyIssuerSignup';
import ManageCompanyIssuers from '../components/IssuerDashboard/ManageCompanyIssuers/ManageCompanyIssuers';
import { useAuth } from '../contexts/authContext';
import IssuerRoutesWrapper from './IssuerRoutesWrapper';
import CompanyBadgePage from '../pages/CompanyBadgePage';

const adminRoutes = [
  { index: true, element: <Navigate to="manage-issuers" /> },
  { path: 'manage-issuers', element: <ManageIssuersByAdmin /> },
  { path: 'manage-credentials', element: <ManageCredentialsByAdmin /> },
  { path: 'manage-assignments', element: <ManageAssignmentsByAdmin /> },
  { path: 'manage-users', element: <ManageUsersByAdmin /> },
  { path: 'manage-companies', element: <ManageCompaniesByAdmin /> },
  { path: 'profile', element: <AdminProfile /> },
  { path: '*', element: <NotFound /> },
];


export const issuerRoutes = [
  { index: true, element: <Navigate to="manage-company-issuers" /> },
  { path: 'manage-company-issuers', element: <ManageCompanyIssuers /> },
  { path: 'manage-assignments', element: <ManageAssignmentsByIssuer /> },
  { path: 'manage-credentials', element: <ManageCredentialsByIssuer /> },
  { path: 'manage-users', element: <ManageUsersByIssuer /> },
  { path: 'manage-companies', element: <ManageCompaniesByIssuer /> },
  { path: 'badge-profile', element: <IssuerBadgesProfile /> },
  { path: 'profile', element: <IssuerProfile /> },
  { path: '*', element: <NotFound /> },
];

export const companyIssuerRoutes = [
  { index: true, element: <Navigate to="manage-assignments" /> },
  { path: 'manage-assignments', element: <ManageAssignmentsByIssuer /> },
  { path: 'manage-credentials', element: <ManageCredentialsByIssuer /> },
  { path: 'manage-users', element: <ManageUsersByIssuer /> },
  { path: 'manage-companies', element: <ManageCompaniesByIssuer /> },
  { path: 'badge-profile', element: <IssuerBadgesProfile /> },
  { path: 'profile', element: <IssuerProfile /> },
  { path: '*', element: <NotFound /> },
];

const userRoutes = [
  { path: '', element: <Navigate to="dashboard" /> },
  { path: 'dashboard', element: <UserDashboard /> },
  { path: 'approve-badges', element: <ApproveBadges /> },
  { path: 'badge-profile', element: <BadgeProfile /> },
  { path: 'profile', element: <UserProfile /> },
  { path: '*', element: <NotFound /> },
];

const router = [
  { path: '/', element: <Navigate to="login" /> },
  { path: 'login', element: <Login /> },
  { path: 'signup', element: <UserSignUp /> },
  { path: 'issuersignup', element: <IssuerSignup /> },
  { path: 'companyissuersignup', element: <CompanyIssuerSignup /> },
  { path: 'access-denied', element: <AccessDenied /> },
  { path: 'adminSignup', element: <AdminSignup /> },
  { path: 'adminSignIn', element: <AdminSignIn /> },
  { path: 'password-reset-success', element: <PasswordResetSuccessMessage /> },
  { path: 'users/:profileId', element: <BadgePage /> },
  // { path: 'issuers/:profileId', element: <IssuerBadgePage /> },
  { path: 'company/:profileId', element: <CompanyBadgePage /> },
  { path: 'assignment/approve/:assignmentIds', element: <ApproveBadgeAssignment /> },
  { path: 'choose-role', element: <RoleSelection /> },
  { path: 'admin/*', element: <ProtectedRoute role="Admin" element={<BaseLayout />} />, children: adminRoutes },
  {
    path: 'issuer/*',
    element: <ProtectedRoute role="Issuer" element={<BaseLayout />} />,
    children: [{ path: '*', element: <IssuerRoutesWrapper /> }],
  },
  // { path: 'issuer/*', element: <ProtectedRoute role="Issuer" element={<BaseLayout />} />, children: issuerRoutes },
  //   { path: 'user/*', element: <ProtectedRoute role="User" element={<BaseLayout />} />, children: [
  //     { element: <ProfileCheck /> }, 
  //     ...userRoutes,
  //   ] 
  // },
  { path: 'user/*', element: <ProtectedRoute role="User" element={<BaseLayout />} />, children: userRoutes },
  // { path: 'admin/*', element: <ProtectedRoute roles={["Admin"]} element={<BaseLayout />} />, children: adminRoutes },
  // { path: 'issuer/*', element: <ProtectedRoute roles={["Issuer"]} element={<BaseLayout />} />, children: issuerRoutes },
  // { path: 'user/*', element: <ProtectedRoute roles={["User"]} element={<BaseLayout />} />, children: userRoutes },

  { path: '*', element: <NotFound /> }
];


export default router;
